import {library, dom} from '@fortawesome/fontawesome-svg-core';
import {faTumblrSquare} from '@fortawesome/free-brands-svg-icons/faTumblrSquare'
import {faLinkedin} from '@fortawesome/free-brands-svg-icons/faLinkedin'
import {faSoundcloud} from '@fortawesome/free-brands-svg-icons/faSoundcloud'
import {faYoutubeSquare} from '@fortawesome/free-brands-svg-icons/faYoutubeSquare'
import {faYoutube} from '@fortawesome/free-brands-svg-icons/faYoutube'
import {faFacebookSquare} from '@fortawesome/free-brands-svg-icons/faFacebookSquare'
import {faTwitterSquare} from '@fortawesome/free-brands-svg-icons/faTwitterSquare'
import {faTwitter} from '@fortawesome/free-brands-svg-icons/faTwitter'
import {faInstagram} from '@fortawesome/free-brands-svg-icons/faInstagram'
import {faPinterestSquare} from '@fortawesome/free-brands-svg-icons/faPinterestSquare'
import {faGooglePlusSquare} from '@fortawesome/free-brands-svg-icons/faGooglePlusSquare'
import {faPhone} from '@fortawesome/pro-light-svg-icons/faPhone';

import {faEnvelope} from '@fortawesome/pro-light-svg-icons/faEnvelope';
import {faUtensils} from '@fortawesome/pro-light-svg-icons/faUtensils';
import {faUtensilsAlt} from '@fortawesome/pro-light-svg-icons/faUtensilsAlt';
import {faUtensilKnife} from '@fortawesome/pro-light-svg-icons/faUtensilKnife';
import {faUtensilSpoon} from '@fortawesome/pro-light-svg-icons/faUtensilSpoon';
import {faUtensilFork} from '@fortawesome/pro-light-svg-icons/faUtensilFork';
import {faCalendarAlt} from '@fortawesome/pro-light-svg-icons/faCalendarAlt';
import {faClock} from '@fortawesome/pro-light-svg-icons/faClock';
import {faUser} from '@fortawesome/pro-light-svg-icons/faUser';
import {faHome} from '@fortawesome/pro-light-svg-icons/faHome';
import {faMinusCircle} from '@fortawesome/pro-light-svg-icons/faMinusCircle';
import {faPlusCircle} from '@fortawesome/pro-light-svg-icons/faPlusCircle';
import {faClipboardList} from '@fortawesome/pro-light-svg-icons/faClipboardList';
import {faAngleRight} from '@fortawesome/pro-light-svg-icons/faAngleRight';
import {faMoneyBillWave} from '@fortawesome/pro-light-svg-icons/faMoneyBillWave';
import {faDownload} from '@fortawesome/pro-light-svg-icons/faDownload';
import {faNewspaper} from '@fortawesome/pro-light-svg-icons/faNewspaper';
import {faPlay} from '@fortawesome/pro-solid-svg-icons/faPlay';
import {faCookieBite} from '@fortawesome/pro-light-svg-icons/faCookieBite';
import {faSearchPlus} from '@fortawesome/pro-light-svg-icons/faSearchPlus';
import {faCamera} from '@fortawesome/pro-light-svg-icons/faCamera';
import {faPencil} from '@fortawesome/pro-light-svg-icons/faPencil';
import {faCopyright} from '@fortawesome/pro-light-svg-icons/faCopyright';
import {faCookie} from '@fortawesome/pro-light-svg-icons/faCookie';

/**
 * Add all the fontawesome icons
 */
export const initFontAwesome = function () {
  library.add([
    faTwitterSquare,
    faGooglePlusSquare,
    faInstagram,
    faYoutubeSquare,
    faLinkedin,
    faPlay,
    faPinterestSquare,
    faSoundcloud,
    faTumblrSquare,
    faFacebookSquare,
    faEnvelope,
    faUtensils,
    faUtensilsAlt,
    faUtensilKnife,
    faUtensilSpoon,
    faUtensilFork,
    faPhone,
    faCalendarAlt,
    faClock,
    faUser,
    faHome,
    faMinusCircle,
    faPlusCircle,
    faClipboardList,
    faAngleRight,
    faMoneyBillWave,
    faYoutube,
    faDownload,
    faNewspaper,
    faSearchPlus,
    faCamera,
    faPencil,
    faCopyright,
    faCookie,
    faCookieBite
  ]);

  dom.watch();

};